import styled from "styled-components";
import {ActionButtonRoot} from "@src/Shared/Components/ActionButton";

export const AddActionButton = styled(ActionButtonRoot)`
  white-space: nowrap;
  padding: 8px !important;
  font-size: 1em;
  margin-top: 0 !important;
  justify-content: left !important;
  text-align: left;
  border-radius: 8px !important;
  :hover {
    background-color: rgb(247, 247, 247);
  } 
`;
